import { mapDetalleToLine } from "./mapDetalleToLine.js";

export const mapDetalleResponseToLines = (detalleResponse) => {
  const items = Array.isArray(detalleResponse)
    ? detalleResponse
    : Array.isArray(detalleResponse?.detalles)
    ? detalleResponse.detalles
    : Array.isArray(detalleResponse?.detalle)
    ? detalleResponse.detalle
    : [];

  return items.map((d) => ({
    ...mapDetalleToLine(d),
    total: d.total,
  }));
};

export const normalizeAlmacenesResponse = (almacenesResponse = {}) => {
  const items = Array.isArray(almacenesResponse)
    ? almacenesResponse
    : Object.values(almacenesResponse || {}).flatMap((value) =>
        Array.isArray(value) ? value : [value],
      );

  return items
    .filter(Boolean)
    .filter((item) => typeof item === "object")
    .filter((item) => item.almacen !== undefined && item.almacen !== null)
    .map((item) => ({
      ...item,
      almacen: String(item.almacen),
      sucursal:
        item.sucursal ?? item.descripcion ?? item.almacen ?? "SIN SUCURSAL",
    }));
};

export const normalizeArticuloKey = (value) => String(value ?? "").trim();

export const applyExistenciaStocks = (existenciaResponse, currentLines) => {
  const stocks = existenciaResponse?.stocks || {};
  const almacenesResponse = existenciaResponse?.almacenes || {};
  const almacenesList = normalizeAlmacenesResponse(almacenesResponse);

  const updatedLines = (currentLines || []).map((line) => {
    const key = normalizeArticuloKey(line.referencia);
    const stockInfo = stocks[key];
    if (!stockInfo) return line;
    const nextStock = stockInfo.stock1 ?? stockInfo.stock ?? line.stock ?? 0;
    return { ...line, stock: nextStock };
  });

  return { updatedLines, almacenesList, stocks };
};
